import { uuid } from '@/utils'

export default [
  {
    cat: 'Рождество',
    id: uuid(),
    ws: [
      'є3гЂпетъ',
      'nсeлъ',
      'гавріи1лъ',
      'ѕвэздA',
      'з0лото',
      'матfeй',
      'смЂрна',
      'бGочlвёкъ',
      'в0лъ',
      'лaданъ',
      'и4рwдъ',
      'є3vсeвій'
    ],
    clue: [
      'Страна, в которую ангел повелел Иосифу бежать по рождении Младенца (Мф. 2:13).',
      'Нередко изображаемое у яслей Спасителя животное, о котором Исаия пророчески сказал, что оно знает «ясли господина своего» (Ис. 1:3).',
      'Архангел, посланный Богом в Назарет к Деве Марии возвестить ей благую весть о Рождении Иисуса Христа (Лк. 1:28-33).',
      'Так назвали волхвы загадочное небесное явление, ознаменовавшее Рождество Спасителя (Мф. 2:1-2).',
      'Драгоценный металл, один из даров волхвов (Мф. 2:9-11).',
      'Один из двух евангелистов, подробно описавших рождение Спасителя.',
      'Ароматическая смола, получаемая из коры деревьев, которую принесли волхвы в дар Спасителю (Мф. 2:9-11).',
      'Кем является Иисус Христос по природе?',
      'Часто изображаемое на иконах Рождества Христова животное, о котором пророк Исаия сказал, что оно знает «владетеля своего» (Ис. 1:3).',
      'Ароматическая древесная смола, благовоние, которое принесли волхвы в дар Спасителю (Мф. 2:9-11).',
      'Царь, узнавший о рождении Мессии и пожелавший уничтожить всех вифлеемских младенцев (Мф. 2:16).',
      'Древний историк, епископ Кесарийский, писавший о храме, сооруженном на месте рождения Спасителя.'
    ],
    pronuns: [
      'Египет',
      'осел',
      'Гавриил',
      'звезда',
      'золото',
      'Матфей',
      'смирна',
      'Богочеловек',
      'вол',
      'ладан',
      'Ирод',
      'Евсевий'
    ],
    xy: [
      [2, 0, 7, 1],
      [1, 2, 5, 1],
      [10, 2, 8],
      [1, 4, 6, 1],
      [4, 4, 6],
      [12, 4, 6],
      [7, 5, 6, 1],
      [2, 9, 9, 1],
      [7, 9, 4],
      [7, 11, 6, 1],
      [3, 12, 5, 1],
      [2, 0, 7]
    ]
  },
  {
    cat: 'Рождество',
    id: uuid(),
    ws: [
      'діонЂсій',
      'с0лнцэ',
      'бGоzвлeніе',
      'и3сaіа',
      'ѓгGлъ',
      'давjдъ',
      'є3мманyилъ',
      'кwнстантjнъ',
      'виfлеeмъ',
      'даніи1лъ',
      'сочeльникъ'
    ],
    clue: [
      'Канонист древней Западной Церкви, вычисливший гипотетическую дату Рождества Христова.',
      'Небесное светило, с которым сравнивается Спаситель в тропаре Рождества Христова.',
      'Христианский праздник, в один день с которым отмечалось Рождество Христово в древней Церкви.',
      'Пророк, которого иногда изображают на иконах Рождества Христова, так как он предрек Рождение Спасителя.',
      'Он сообщил пастухам о рождении Спасителя (Лк. 2:9).',
      'Царь и пророк, потомками которого были Мария и Иосиф (Лк. 1:27).',
      'Одно из пророческих имен Иисуса Христа, употребленное в пророчестве Исаии о рождении Спасителя (Ис. 7:14).',
      'Римский император IV века, соорудивший храм над пещерой, в которой родился Младенец Иисус.',
      'Селение в Иудее, в которое пошли Мария и Иосиф из-за переписи населения Римской империи (Мф. 2:4-7).',
      'Пророк, предсказавший почти за 500 лет до Рождества Спасителя время Его явления (Дан. 9:24-25).',
      'Канун праздника Рождества Христова.'
    ],
    pronuns: [
      'Дионисий',
      'Солнце',
      'Богоявление',
      'Исайя',
      'ангел',
      'Давид',
      'Еммануил',
      'Константин',
      'Вифлеем',
      'Даниил',
      'сочельник'
    ],
    xy: [
      [3, 0, 8, 1],
      [0, 2, 6, 1],
      [9, 3, 10],
      [5, 4, 5],
      [7, 4, 5, 1],
      [12, 7, 6],
      [2, 8, 9, 1],
      [0, 10, 11, 1],
      [5, 12, 8, 1],
      [3, 0, 7],
      [0, 2, 10]
    ]
  },
  {
    cat: 'Рождество',
    id: uuid(),
    ws: [
      'лівaнъ',
      'ћсли',
      'њбрyчникъ',
      'бlговолeніе',
      'волсви2',
      'ї}съ',
      'їеrли1мъ',
      'пaстыріе',
      'міхeй',
      'назарeтъ'
    ],
    clue: [
      'Собственно, в церковнославянском тексте это означает "ладан".',
      'Кормушка для домашних животных, в которую, как колыбель был положен Младенец по рождении.',
      'Так называют праведного Иосифа.',
      'Завершите фразу: "Слава в вышних Богу, и на земли мир, в человецех …".',
      'Персонажи Евангелия от Матфея, пришедшие "с востока" поклониться родившемуся Младенцу (Мф. 2, 1-12).',
      'Имя, которое нарек праведный Иосиф родившемуся Младенцу.',
      'Город, в который пришли волхвы, чтобы узнать, где родился Христос.',
      'В церковнославянском тексте это слово означает "пастухи".',
      'Ветхозаветный пророк, предсказавший, что Спаситель родится в Вифлееме (Мих. 5:4-5).',
      'Город, в котором поселилось Святое семейство после возвращения из Египта.'
    ],
    pronuns: [
      'ливан',
      'ясли',
      'обручник',
      'благоволение',
      'волсви',
      'Иисус',
      'Иерусалим',
      'пастырие',
      'Михей',
      'Назарет'
    ],
    xy: [
      [12, 0, 6],
      [6, 1, 4],
      [0, 2, 9],
      [0, 3, 11, 1],
      [4, 3, 6],
      [9, 5, 4, 1],
      [9, 5, 7],
      [2, 6, 8, 1],
      [7, 8, 5],
      [2, 11, 8, 1]
    ]
  },
  {
    cat: 'Введение',
    id: uuid(),
    ws: [
      'їHсифъ',
      'ѓнна',
      'назарeтъ',
      'їwакjмъ',
      'захaріа',
      'рукодёліе',
      'мlтва',
      'три2',
      'ѓгGлъ',
      'паламA',
      'цэломyдріе',
      'їеrли1мъ'
    ],
    clue: [
      'Чьим заботам была поручена Мария по прошествии пребывания во Храме?',
      'Праведная, мать Пресвятой Богородицы.',
      'В каком городе родилась Пресвятая Богородица?',
      'Праведный, отец Пресвятой Богородицы.',
      'Первосвященник,по Преданию, встретивший в храме юную Марию.',
      'Труд, которым занималась Пресвятая Богородица, живя при храме.',
      'Пост и … - вот что праведный Иоаким возложил на себя, чтобы Господь послал им чадо.',
      'Сколько лет исполнилось Приснодеве, когда ее отдали на воспитание в Иерусалимский Храм?',
      'Кто явился с вестью о предстоящем рождении ребенка св. прав. Анне?',
      'Фамилия свт. Григория, наиболее полно давшего богословское толкование Введения Богородицы во Храм.',
      'Какая добродетель помогла святым супругам стать родителями Богоматери?',
      'Город, в котором находился Храм.'
    ],
    pronuns: [
      'Иосиф',
      'Анна',
      'Назарет',
      'Иоаким',
      'Захария',
      'рукоделие',
      'молитва',
      'три',
      'Ангел',
      'Палама',
      'целомудрие',
      'Иерусалим'
    ],
    xy: [
      [1, 0, 6, 1],
      [4, 2, 4, 1],
      [5, 2, 8],
      [11, 2, 7],
      [5, 4, 7, 1],
      [9, 4, 9],
      [1, 5, 5, 1],
      [5, 8, 3, 1],
      [1, 9, 5, 1],
      [7, 10, 6, 1],
      [0, 12, 10, 1],
      [1, 0, 7]
    ]
  },
  {
    cat: 'Покров',
    id: uuid(),
    ws: [
      'херувjмы',
      'васjлій',
      'н0вгородъ',
      'рyсичи',
      'тропaрь',
      'nмоф0ръ',
      'боголю1бскій',
      'ґндрeй',
      'рwмaнъ',
      'пр0логъ',
      'вели1кій'
    ],
    clue: [
      'В молитве «Достойно есть» упоминается ангельский чин, по близости к Господу равный Богородице.',
      'Известный московский собор в честь Покрова Божией Матери часто называют храмом этого блаженного.',
      'Старинный город на Руси, с которым связан один из иконографических изводов Покрова.',
      'Славянский народ, напавший в начале X века на Константинополь.',
      'Как называется стихословие, в котором кратко излагается смысл Праздника?',
      'Что распростерла Владычица над людьми?',
      'Прозвище княза Андрея, стараниями которого на Руси в XII в. был установлен праздник покрова Пресвятой Богородицы.',
      'Блаженный, в видении которому явилась пресв. Богородица с сонмом святых.',
      'Христианский святой V-VI вв., гимнограф, нередко изображающийся на иконах Покрова.',
      'Как называется древнерусский житийный сборник, из которого мы узнаем об установлении Праздника?',
      'К числу каких категорий праздников относится Покров?'
    ],
    pronuns: [
      'Херувимы',
      'Василий',
      'Новгород',
      'русичи',
      'тропарь',
      'омофор',
      'Боголюбский',
      'Андрей',
      'Роман',
      'пролог',
      'великий'
    ],
    xy: [
      [5, 0, 8, 1],
      [9, 0, 7],
      [1, 1, 9],
      [7, 2, 6, 1],
      [3, 3, 7],
      [12, 4, 7],
      [0, 5, 11, 1],
      [7, 7, 6],
      [3, 8, 6, 1],
      [6, 10, 7, 1],
      [1, 12, 7, 1]
    ]
  },
  {
    cat: 'Троица',
    id: uuid(),
    ws: [
      'берeза',
      'їеrлjмъ',
      'вознесeніе',
      'зелeный',
      'їwи1ль',
      'стzжaніе',
      'пентик0стіz',
      'тріHдь',
      'лукA',
      'џгнь',
      'пavелъ'
    ],
    clue: [
      'Дерево, ветками которого, по русской традиции, украшают храмы в день Святой Троицы',
      'Город, в котором по повелению Господа находились апостолы в день сошествия Святого Духа',
      'Великий Праздник, предшествующий Пятидесятнице',
      'Цвет, который имеют богослужебные облачения в праздник Троицы',
      'Пророк, предсказавший сошествие Святого Духа на апостолов, о котором говорит апостол Петр',
      'По своему ближайшему смысловому значению данный термин подразумевает: “приобретение”, “накопление”',
      'Слово Пятидесятница по-гречески',
      'Книга, в которой содержится последование Богослужения Дня Святой Троицы',
      'Автор книги Деяний святых апостолов, в которой мы встречаем рассказ о христианской Пятидесятнице',
      'То, под видом чего Святой Дух сошел на апостолов в день Пятидесятницы',
      'Изображаемый на иконах Пятидесятницы святой, который не был на момент этого события апостолом'
    ],
    pronuns: [
      'береза',
      'Иерусалим',
      'Вознесение',
      'зеленый',
      'Иоиль',
      'стяжание',
      'Пентикостия',
      'Триодь',
      'Лука',
      'Огнь',
      'Павел'
    ],
    xy: [
      [7, 0, 6],
      [6, 1, 7, 1],
      [1, 3, 10, 1],
      [3, 3, 7],
      [0, 5, 5, 1],
      [11, 5, 8],
      [1, 7, 11, 1],
      [9, 7, 6],
      [1, 11, 4, 1],
      [6, 12, 4, 1],
      [1, 7, 6]
    ]
  },
  {
    cat: 'пасха',
    id: uuid(),
    ws: [
      'кули1чъ',
      'вертогрaдарь',
      'пeтръ',
      'є3vхари1стіа',
      'и4сповэдь',
      'марjа',
      'хrт0съ',
      'ѓртосъ',
      'вaіа',
      'їwaннъ',
      'ќтренz',
      'кустодjа'
    ],
    clue: [
      'Пасхальный праздничный хлеб.',
      'Мария Магдалина, встретившая воскресшаго Христа, думала, что это садовник.',
      'Кто из апостолов вошел во Гроб и увидел пелены лежащие и плат?',
      'Таинство, установленное на Тайной Вечери.',
      'Таинство, имеющее основание в Евангелии, как установленное Господом.',
      'Имя святой, которая, по преданию, поднесла императору Тиберию яйцо со словами: "Христос Воскресе!"',
      'Кто воскрес?',
      'Он всю Светлую Седмицу хранится в храме, на аналое перед иконостасом, а в субботу пасхальную раздробляется и раздается верующим как святыня.',
      'Это освящают в вербное воскресенье, предшествующее празднику Пасхи.',
      'Имя святого, "слово огласительное" которого читается на пасхальном Богослужении.',
      'Пасхальное общественное богослужение, которое начинает служиться после крестного хода в притворе благословением и пением пасхального тропаря.',
      'Стража, караул.'
    ],
    pronuns: [
      'кулич',
      'вертоградарь',
      'Пётр',
      'Евхаристия',
      'исповедь',
      'Мария',
      'Христос',
      'Артос',
      'вайя',
      'Иоанн',
      'Утреня',
      'кустодия'
    ],
    xy: [
      [2, 0, 6, 1],
      [9, 0, 12],
      [11, 0, 5],
      [0, 1, 10],
      [4, 2, 8],
      [7, 2, 5],
      [0, 3, 6, 1],
      [6, 4, 6, 1],
      [4, 6, 4, 1],
      [11, 7, 6],
      [7, 10, 6, 1],
      [2, 0, 8]
    ]
  },
  {
    cat: 'азбука',
    id: uuid(),
    ws: [
      'њмeга',
      'сл0во',
      'ћть',
      'глаг0ль',
      'лю1ди',
      'живёте',
      'добро2',
      'бyки',
      'вёди',
      'w4тъ',
      'fитA'
    ],
    clue: [
      'W, w, Q, q',
      'С, с',
      'Э, э',
      'Г, г',
      'Л, л',
      'Ж, ж',
      'Д, д',
      'Б, б',
      'В, в',
      'T, t',
      'F, f'
    ],
    pronuns: [
      'омeга',
      'слово',
      'ять',
      'глаголь',
      'люди',
      'живете',
      'добро',
      'буки',
      'веди',
      'отъ',
      'фита'
    ],
    xy: [
      [5, 2, 5],
      [7, 4, 5],
      [9, 4, 3],
      [3, 6, 7, 1],
      [4, 6, 4],
      [1, 7, 6],
      [6, 8, 5, 1],
      [8, 8, 4],
      [1, 9, 4, 1],
      [0, 11, 3, 1],
      [7, 11, 4, 1]
    ]
  },
  {
    cat: 'азбука',
    id: uuid(),
    ws: [
      'чeрвь',
      'ѓзъ',
      'фeртъ',
      'землS',
      'мыслёте',
      'є4сть',
      'твeрдо',
      'џнъ',
      'нaшъ',
      'шA',
      'цы2',
      'хёръ',
      'рцы2',
      'и4же',
      'пок0й',
      'кaкw',
      'џникъ',
      'є4ръ'
    ],
    clue: [
      'Ч, ч',
      'А, а',
      'Ф, ф',
      'З, з',
      'М, м',
      'Е, е, є',
      'Т, т',
      'O, o, О, о',
      'Н, н',
      'Ш, ш',
      'Ц, ц',
      'Х, х',
      'Р, р',
      'И, и',
      'П, п',
      'К, к',
      'Ў, ў, У, у',
      'Ъ, ъ'
    ],
    pronuns: [
      'червь',
      'азъ',
      'ферт',
      'земля',
      'мыслете',
      'есть',
      'твердо',
      'он',
      'наш',
      'ша',
      'цы',
      'хер',
      'рцы',
      'иже',
      'покой',
      'како',
      'оник',
      'еръ'
    ],
    xy: [
      [10, 0, 5],
      [12, 0, 3],
      [8, 2, 5, 1],
      [0, 3, 5, 1],
      [2, 3, 7],
      [7, 4, 4, 1],
      [9, 4, 6],
      [4, 5, 3],
      [4, 6, 4, 1],
      [6, 6, 2],
      [11, 6, 2],
      [1, 7, 4, 1],
      [9, 7, 3, 1],
      [0, 9, 3, 1],
      [8, 9, 5, 1],
      [10, 9, 4],
      [7, 11, 5, 1],
      [7, 4, 3]
    ]
  },
  {
    cat: 'человек',
    id: uuid(),
    ws: [
      'плещи2',
      'џчи',
      'nчесA',
      'междорaміе',
      'десни1ца',
      'пeрстъ',
      'мhшца',
      'нёдро',
      'лани1та',
      'плеснЁ∙мои2',
      'плюновeніе',
      'џко',
      'пeрси',
      'л0но'
    ],
    clue: [
      'плечи',
      'глаза',
      'глаза',
      'междуплечие, спина',
      'правая рука',
      'палец',
      'плечо; сила',
      'грудь, пазуха, нутро; залив',
      'щека',
      'ноги мои',
      'слюна',
      'глаз',
      'грудь',
      'недро, грудь (как символ ласки, нежности, материнства)'
    ],
    pronuns: [
      'плещи',
      'очи',
      'очеса',
      'междорамие',
      'десница',
      'перст',
      'мышца',
      'недро',
      'ланита',
      'плесне мои',
      'плюновение',
      'око',
      'перси',
      'лоно'
    ],
    xy: [
      [0, 0, 5, 1],
      [7, 1, 3, 1],
      [12, 1, 5],
      [3, 3, 10, 1],
      [6, 3, 7],
      [3, 5, 6, 1],
      [10, 5, 5],
      [0, 7, 5, 1],
      [5, 9, 6, 1],
      [1, 11, 10, 1],
      [0, 0, 10],
      [7, 1, 3],
      [3, 5, 5],
      [5, 9, 4]
    ]
  },
  {
    cat: 'человек',
    id: uuid(),
    ws: [
      'чрeсла',
      'рaмо',
      'стрyпъ',
      'р0гъ',
      'чело2',
      'стомaхъ',
      'џчію∙моeю',
      'стопA',
      'прaхъ',
      'чрeво',
      'длaнь',
      'ўстA',
      'трyпъ',
      'скрaніz',
      'человёчь'
    ],
    clue: [
      'поясница',
      'плечо',
      'гнилая рана',
      'символ силы, крепости',
      'лоб',
      'желудок',
      'глаз моих',
      'ступня; шаг; нога',
      'пыль',
      'живот',
      'ладонь',
      'рот, губы',
      'мертвое тело',
      'висок',
      'человеческий'
    ],
    pronuns: [
      'чресла',
      'рамо',
      'струп',
      'рог',
      'чело',
      'стомах',
      'очию моею',
      'стопа',
      'прах',
      'чрево',
      'длань',
      'уста',
      'труп',
      'скрания',
      'человечь'
    ],
    xy: [
      [0, 0, 6],
      [2, 0, 4],
      [4, 0, 6, 1],
      [6, 0, 4],
      [8, 2, 4, 1],
      [0, 3, 7, 1],
      [2, 5, 9, 1],
      [12, 6, 5],
      [6, 7, 5],
      [8, 8, 5, 1],
      [4, 9, 5, 1],
      [2, 9, 4],
      [2, 11, 5, 1],
      [4, 0, 7],
      [8, 2, 8]
    ]
  },
  {
    cat: 'искус',
    id: uuid(),
    ws: [
      'м§никъ',
      'нLz',
      'вLко',
      'бцdа',
      'вLчица',
      'єђліе',
      'дв7а',
      'чlвэколю1бецъ',
      'бlже',
      'цRю2',
      'џ§е',
      'многомлcтивый',
      'дш7е'
    ],
    clue: [
      'Человек, принявший мучения и смерть за исповедание веры в Иисуса Христа.',
      'По-церковнославянски это воскресенье',
      'Обращение к сотворившему небо и землю',
      'Божия Матерь',
      'Небесная Заступница',
      'Священная книга от апостолов',
      'Дочь праведных Иоакима и Анны',
      'Тот, Кто полон человеколюбия, любви к людям.',
      'Обращение к Духу Святому',
      'Обращение к Духу Святому',
      'Отец Наш небесный',
      'Всегда готовый содействовать благополучию других; весьма склонный к милости, милосердию.',
      'Обращение к Утешителю'
    ],
    pronuns: [
      'мученик',
      'неделя',
      'владыко',
      'Богородица',
      'владычица',
      'Евангелие',
      'дева',
      'человеколюбец',
      'блаже',
      'царю',
      'отче',
      'многомилостивый',
      'душе'
    ],
    xy: [
      [3, 0, 6, 1],
      [5, 0, 3],
      [0, 4, 4, 1],
      [12, 5, 3],
      [1, 7, 6],
      [7, 7, 5],
      [10, 7, 3, 1],
      [1, 9, 12, 1],
      [9, 9, 4],
      [11, 9, 3],
      [5, 11, 3, 1],
      [3, 0, 12],
      [10, 7, 3]
    ]
  },
  {
    cat: 'искус',
    id: uuid(),
    ws: [
      'гlг0лъ',
      'гDь',
      'ї}ль',
      'м®ость',
      'нб7о',
      'хrт0съ',
      'с™hй',
      'б9ій',
      'ґпcлъ',
      'ї}съ',
      'бGъ'
    ],
    clue: [
      'Глас Бога от Него или через святых.',
      '... и Бог наш Иисус Христос благодатию и щедротами своего человеколюбия.',
      'Народ Божий',
      'Дается свыше',
      'Туда восходят праведники.',
      'Центральная личность и предсказанный в Ветхом Завете Мессия, ставший искупительной жертвой за грехи людей.',
      'Одно из слов в молитве «Трисвятое».',
      'Человек ...',
      'Так называют учеников Христовых, отправленных Им проповедовать Евангелие и устраивать Церковь.',
      'Имя Спасителя',
      'Его не следует поминать всуе.'
    ],
    pronuns: [
      'глагол',
      'Господь',
      'Израиль',
      'мудрость',
      'небо',
      'Христос',
      'святый',
      'Божий',
      'апостол',
      'Иисус',
      'Бог'
    ],
    xy: [
      [10, 0, 6],
      [10, 2, 3, 1],
      [8, 4, 4, 1],
      [5, 3, 6],
      [3, 5, 3, 1],
      [3, 7, 6, 1],
      [7, 7, 4],
      [4, 10, 4, 1],
      [1, 12, 4, 1],
      [8, 4, 4],
      [4, 10, 3]
    ]
  },
  {
    cat: 'Богослужение',
    id: uuid(),
    ws: [
      'возлю1бленніи',
      'во∙врeмz∙џно',
      'чaдо',
      'є3ђліе',
      'зачaло',
      'гл†вы',
      'брaтіе',
      'fе0дwръ',
      'ст0лпъ',
      'їwaннъ',
      'ґп0столъ'
    ],
    clue: [
      'Обращение ап. Иоанна к ученикам.',
      'фраза "в некоторое время" будет звучать как …',
      'Как ап. Павел обращается к Тимофею?',
      'Книга, зачала из которой читаются на литургии после их чтения из Апостола.',
      'Единица деления новозаветного текста, читаемого за церковным богослужением.',
      'Кроме деления на зачала, имеется деление на:',
      'Как ап. Павел обращается к другим апостолам и ученикам?',
      'Имя одного из святых, которому приписывается составление порядка рядовых чтений из Евангелия и Апостола.',
      'Как называется "набор" воскресных утренних Евангелий (11 ед.)?',
      'Имя апостола, в Евангелии от которого зачал меньше всех.',
      'Наименование книги Нового завета, в котором зачал больше всех.'
    ],
    pronuns: [
      'возлюбленнии',
      'во врeмя оно',
      'чадо',
      'Евангелие',
      'зачало',
      'главы',
      'братие',
      'Феодор',
      'столп',
      'Иоанн',
      'Апостол'
    ],
    xy: [
      [3, 0, 12],
      [10, 0, 12],
      [0, 1, 4, 1],
      [8, 1, 5],
      [5, 2, 6],
      [7, 3, 5, 1],
      [3, 5, 6, 1],
      [1, 5, 7],
      [12, 6, 6],
      [0, 9, 6, 1],
      [5, 11, 8, 1]
    ]
  },
  {
    cat: 'Богослужение',
    id: uuid(),
    ws: [
      'ґнтіми1нсъ',
      'ґнал0й',
      'літургjz',
      'чти1ти',
      'часосл0въ',
      'ѓртосъ',
      'чи1нъ',
      'ли1къ',
      'литіS',
      'ґнтіфHнъ',
      'ґнтідHръ'
    ],
    clue: [
      'Плат с частицами святых мощей и изображением положения во гроб тела Иисуса Христа, полагаемый на престоле для совершения Евхаристии.',
      'Собственно значит соответствие, согласие. Аналогием называется возвышенный стол, на котором читается Евангелие, полагаются иконы.',
      'Священнослужение, в котором совершается таинство Евхаристии; обедня.',
      'чтить, почитать',
      'Богослужебная книга со всеми молитвословиями для чтения и пения на всех церковных службах (кроме Литургии).',
      'Квасный хлеб, освящаемый в первый день Святой Пасхи и раздробляемый в субботу Светлой седмицы для раздачи народу.',
      'порядок, устав',
      '1) хор; 2) собор святых (лик ангельский); 3) образ, начертание лица (лик святого).',
      'Священнодействие, совершаемое в притворе храма; краткое молитвословие об упокоении умерших.',
      'Краткий стих, который по окончании пения на одном клиросе повторяется на другом.',
      'Частицы просфоры, из которой вынут агнец, раздаваемые присутствующим в храме после Литургии. Антидор - вместо дара.'
    ],
    pronuns: [
      'антиминс',
      'аналой',
      'литургия',
      'чтити',
      'часослов',
      'артос',
      'чин',
      'лик',
      'лития',
      'антифон',
      'антидор'
    ],
    xy: [
      [1, 0, 9],
      [3, 0, 6, 1],
      [6, 0, 8],
      [0, 2, 5, 1],
      [9, 2, 9],
      [5, 4, 6, 1],
      [12, 4, 4],
      [9, 7, 4, 1],
      [4, 8, 5],
      [2, 10, 8, 1],
      [3, 0, 8]
    ]
  },
  {
    cat: 'Богослужение',
    id: uuid(),
    ws: [
      'свzти1лище',
      'хвалeніе',
      'чaсъ',
      'хвaленъ',
      'ќтреневати',
      'тропaрь',
      'тр0иченъ',
      'предложeніе',
      'трі0дь',
      'ўрaнити',
      'хвали1те'
    ],
    clue: [
      'средняя часть скинии и храма, куда входили священники',
      'прославление',
      'означает в Писании неопределенное время (Мф. 10:19; Лк. 12:12); иногда означает время кончины человека (Мк. 13:32; Ин. 5:28, 7:30, 8:2)',
      'достойный прославления',
      'рано вставать (Пс. 126:2); совершать утреннюю молитву (Пс. 62:1)',
      'песнопение, в котором кратко выражается сущнось праздника или образ жизни святого',
      'песнь в честь Пресвятой Троицы',
      'стол священный с хлебами в скинии и храме',
      '(трипеснец); церковная богослужебная книга; название сове получила от того, что каноны, помещенные в ней, состоят по большей части из трех песней (трипеснцы). Есть Триодь Постная - содержащая службы от Недели мытаря и фарисея до Пасхи; Триодь Цветная, в которой содержатся службы от Пасхи до Недели Всех святых',
      'встать рано утром',
      'стихиры, которые поются на утрени после канона. Название свое получили от припевов, которые начинаются словом «хвалите»'
    ],
    pronuns: [
      'святилище',
      'хваление',
      'час',
      'хвален',
      'утреневати',
      'тропарь',
      'троичен',
      'предложение',
      'триодь',
      'уранити',
      'хвалите'
    ],
    xy: [
      [3, 0, 9],
      [5, 0, 8, 1],
      [7, 3, 4],
      [9, 3, 7],
      [11, 3, 10],
      [1, 5, 7],
      [0, 6, 8, 1],
      [1, 8, 11, 1],
      [0, 10, 6, 1],
      [6, 11, 7, 1],
      [5, 0, 7]
    ]
  },
  {
    cat: 'Богослужение',
    id: uuid(),
    ws: [
      'предстоsтель',
      'свzти1тель',
      'трипёснецъ',
      'трисвzт0е',
      'просфорA',
      'смЂрна',
      'свёщникъ',
      'свzти1ло',
      'притв0ръ',
      'прокjменъ'
    ],
    clue: [
      'настоятель, старшина',
      'архиерей',
      'канон из трех песней',
      'молитва «Святый Боже…»',
      'хлеб пшеничный, квасный, приносимый на Литургии, наверху которого знамение креста с надписями, в переводе гласящих «Христос побеждает».',
      'благовонная смола',
      'подсвечник',
      'средняя часть скинии и храма, куда входили священники',
      '1) паперть (Ин. 10:23); 2) крытый ход, галерея (Ин. 5:2)',
      'краткий стих из Священного Писания, поемый перед чтением Апостола, Евангелия и паремий'
    ],
    pronuns: [
      'предстоятель',
      'святитель',
      'трипеснец',
      'трисвятое',
      'просфора',
      'смирна',
      'свещник',
      'святило',
      'притвор',
      'прокимен'
    ],
    xy: [
      [0, 0, 12],
      [4, 0, 9, 1],
      [9, 0, 10],
      [7, 2, 9],
      [3, 3, 8],
      [0, 4, 6, 1],
      [11, 5, 8],
      [5, 6, 7],
      [2, 9, 8, 1],
      [3, 12, 9, 1]
    ]
  },
  {
    cat: 'склонности',
    id: uuid(),
    ws: [
      'ўщeдрити',
      'труждaтисz',
      'ўхaніе',
      'цэловaніе',
      'цёлъ',
      'ўповaніе',
      'ўкрочaти',
      'чazти',
      'ўр0дъ',
      'хищeніе',
      'ўпок0ити'
    ],
    clue: [
      'оказать щедрость, милость',
      'трудиться, затрудняться, изнемогать от непосильного труда',
      'обоняние',
      '1) поцелуй; 2) приветствие (Лк. 1:41)',
      '2) здравый (Ин. 5:6); 2) незлобивый',
      'твердая надежда',
      'усмирять, укрощать (Пс. 88:10)',
      'ожидать',
      'безумный, глупый',
      'воровство, грабеж',
      'доставить покой, успокоить'
    ],
    pronuns: [
      'ущедрити',
      'труждатися',
      'ухание',
      'целование',
      'цел',
      'упование',
      'укрочати',
      'чаяти',
      'урод',
      'хищение',
      'упокоити'
    ],
    xy: [
      [3, 0, 8, 1],
      [9, 0, 10],
      [12, 0, 6],
      [7, 2, 9],
      [0, 4, 4, 1],
      [5, 5, 8, 1],
      [2, 7, 8, 1],
      [1, 10, 5, 1],
      [3, 0, 5],
      [4, 12, 7, 1],
      [5, 5, 8]
    ]
  },
  {
    cat: 'склонности',
    id: uuid(),
    ws: [
      'соблажнsти',
      'стужaти',
      'трезви1тисz',
      'скоктaніе',
      'тaть',
      'стужeніе',
      'слaный',
      'стyдъ',
      'татьбA',
      'сyетный',
      'трeпетенъ',
      'суетA'
    ],
    clue: [
      'вовлекать в грех',
      'теснить, досаждать',
      'воздерживаться от излишеств; бодрствовать',
      'щекотание, подстрекательство',
      'вор, похититель',
      'угнетение, преследование',
      'соленый',
      'стыд, посрамление',
      'воровство, кража',
      'напрасный, тщетный',
      'дрожащий от испуга',
      'ничтожность, пустота'
    ],
    pronuns: [
      'соблажняти',
      'стужати',
      'трезвитися',
      'скоктание',
      'тать',
      'стужение',
      'сланый',
      'студ',
      'татьба',
      'суетный',
      'трепетен',
      'суета'
    ],
    xy: [
      [2, 0, 10, 3],
      [0, 1, 7],
      [0, 2, 10, 1],
      [8, 2, 9],
      [6, 4, 4],
      [10, 5, 8],
      [12, 5, 6],
      [3, 6, 5],
      [3, 7, 6, 1],
      [6, 10, 7, 1],
      [4, 12, 9, 1],
      [2, 0, 5]
    ]
  },
  {
    cat: 'склонности',
    id: uuid(),
    ws: [
      'суесл0въ',
      'сладкопёніе',
      'сокрушeнъ',
      'слези1ти',
      'ск0тенъ',
      'смирeніе',
      'смотрёніе',
      'соблaзнъ',
      'сматрsти'
    ],
    clue: [
      'пустослов',
      'приятное, усладительное пение',
      'разбит, надломлен; сетующий о грехах (Пс. 50:19; Лк. 4:18)',
      'проливать слезы, плакать',
      'подобный скоту',
      'смирение',
      'забота',
      'искушение',
      'подсматривать'
    ],
    pronuns: [
      'суеслов',
      'сладкопение',
      'сокрушен',
      'слезити',
      'скотен',
      'смирение',
      'смотрение',
      'соблазн',
      'сматряти'
    ],
    xy: [
      [5, 0, 8],
      [11, 0, 11],
      [1, 1, 9, 1],
      [7, 3, 7],
      [3, 5, 7, 1],
      [5, 9, 8, 1],
      [0, 11, 9, 1],
      [1, 1, 8],
      [3, 5, 8]
    ]
  },
  {
    cat: 'животные',
    id: uuid(),
    ws: [
      'превитaти',
      'руно2',
      'пaзнокти',
      'прyжіе',
      'скни1па',
      'паучи1на',
      'nнaгръ',
      'пэтлоглашeніе',
      'скЂменъ',
      'пернaтыz',
      'пётелъ'
    ],
    clue: [
      'скитаться, странствовать, переезжать («Превитай по горам, яко птица.» (Пс. 10:1)',
      'шерсть, овчина',
      'копыта',
      'саранча',
      'вошь',
      'паутина',
      'дикий осел',
      'пение петухов',
      'львенок, молодой лев',
      'имеющие перья; крылья; птицы',
      'петух'
    ],
    pronuns: [
      'превитати',
      'руно',
      'пазнокти',
      'пружие',
      'скнипа',
      'паучина',
      'онагр',
      'петлоглашение',
      'скимен',
      'пернатыя',
      'петел'
    ],
    xy: [
      [4, 0, 9, 1],
      [5, 0, 4],
      [2, 2, 8, 1],
      [12, 2, 6],
      [0, 5, 6, 1],
      [7, 6, 7],
      [10, 6, 6],
      [0, 7, 13, 1],
      [2, 11, 7, 1],
      [2, 2, 8],
      [0, 7, 6]
    ]
  },
  {
    cat: 'животные',
    id: uuid(),
    ws: [
      'nвeнъ',
      'нощнhй∙врaнъ',
      'г0рличище',
      'к0кошь',
      'ли1съ',
      'крило2',
      'врaбій',
      'зобaти',
      'нhрище',
      'неsсыть',
      'мeскъ',
      'nвчA'
    ],
    clue: [
      'баран',
      'филин, сова',
      'дикий голубь',
      'курица-наседка',
      'лисица',
      'крыло',
      'воробей',
      'наполнять зоб, хватать клювом, клевать',
      'нора в песке; развалины',
      'пеликан; птица, живущая на водах. Неясыть пустынная - пеликан',
      'мул, лошак',
      'овца'
    ],
    pronuns: [
      'овен',
      'нощный вран',
      'горличище',
      'кокошь',
      'лис',
      'крило',
      'врабий',
      'зобати',
      'нырище',
      'неясыть',
      'меск',
      'овча'
    ],
    xy: [
      [2, 0, 5, 1],
      [5, 0, 12],
      [8, 0, 9],
      [7, 1, 6, 1],
      [8, 3, 4, 1],
      [1, 4, 5],
      [0, 5, 6, 1],
      [10, 6, 6],
      [3, 8, 6, 1],
      [5, 10, 7, 1],
      [1, 11, 5, 1],
      [2, 0, 4]
    ]
  },
  {
    cat: 'животные',
    id: uuid(),
    ws: [
      'є3родjа',
      'врaнъ',
      'велблyдъ',
      'є3хjдна',
      'жребS',
      'ґкрjда',
      'є3лeнь',
      'ѓспідъ',
      'васілjскъ',
      'ґлeктwръ',
      'вeпрь'
    ],
    clue: [
      'цапля, аист',
      'ворон',
      'верблюд',
      'ядовитая змея',
      'жеребенок',
      'саранча',
      'олень',
      'ядовитая змея',
      'ядовитая змея',
      'петух',
      'кабан, дикая свинья'
    ],
    pronuns: [
      'еродия',
      'вран',
      'велблуд',
      'ехидна',
      'жребя',
      'акрида',
      'елень',
      'аспид',
      'василиск',
      'алектор',
      'вепрь'
    ],
    xy: [
      [5, 0, 6],
      [4, 1, 5, 1],
      [10, 1, 8],
      [3, 3, 6],
      [7, 4, 5, 1],
      [0, 5, 6, 1],
      [6, 7, 5],
      [8, 7, 6],
      [2, 8, 9, 1],
      [0, 5, 8],
      [2, 8, 5]
    ]
  },
  {
    cat: 'искус',
    id: uuid(),
    ws: [
      'и3скушeніе',
      'ѓxіwсъ',
      'xенофHнтъ',
      'њслэпи1ти',
      'тімоfeй',
      'tкровeніе',
      'таjсіа',
      'покаsніе',
      'ѕeліе',
      'pалти1рь'
    ],
    clue: [
      'Ты этого достоин!',
      'Возглас - Достоин!',
      'Имя мальчика на букву КС',
      'Направить яркий свет в глаза',
      'Имя мальчика на букву Т',
      'Озарение свыше',
      'Имя девочки на букву Т',
      'Не равно раскаянию',
      'Трава луговая',
      'Священная книга царя Давида'
    ],
    pronuns: [
      'Искушение',
      'Аксиос',
      'Ксенофонт',
      'Ослепити',
      'Тимофей',
      'Откровение',
      'Таисия',
      'Покаяние',
      'Зелие',
      'Псалтирь'
    ],
    xy: [
      [12, 0, 9],
      [4, 1, 6, 1],
      [5, 1, 9],
      [0, 3, 8],
      [9, 3, 7],
      [2, 4, 9, 1],
      [3, 6, 6],
      [0, 7, 8, 1],
      [8, 8, 5, 1],
      [2, 11, 7, 1]
    ]
  },
  {
    cat: 'Cерафим',
    id: uuid(),
    ws: [
      'мотhга',
      'є3ђліе',
      'прпdбный',
      'ніколaй',
      'сар0въ',
      'дивeево',
      'купeцъ',
      'снhть',
      'плaменный',
      'бцdа',
      'пyстынька',
      'медвёдь',
      'серафjмъ'
    ],
    clue: [
      'Каким инструментом обрабатывал святой землю?',
      'Какую книгу знал наизусть святой?',
      'В каком лике прославлен святой старец?',
      'Как звали царя, который прославил святого в 1903 году?',
      'В каком граде всю жизнь жил святой старец?',
      'Где в настоящее время покоятся его мощи?',
      'Кем был его отец?',
      'Как называется лесная трава, которой святой питался целых два года?',
      'Что означает его имя, прославленное во святых?',
      'Она являлась святому старцу 12 раз.',
      'Как называется дом святого, в котором он жил?',
      'Какого лесного зверя кормил старец из своих рук?',
      'Как именуют святого?'
    ],
    pronuns: [
      'мотыга',
      'Евангелие',
      'преподобный',
      'николай',
      'Саров',
      'Дивеево',
      'купец',
      'сныть',
      'пламенный',
      'Богородица',
      'пустынька',
      'медведь',
      'Серафим'
    ],
    xy: [
      [4, 1, 6, 1],
      [0, 2, 5, 1],
      [6, 3, 7, 1],
      [10, 3, 7],
      [0, 4, 6, 1],
      [4, 6, 7, 1],
      [2, 7, 6],
      [7, 8, 5],
      [2, 9, 9, 1],
      [12, 9, 3],
      [4, 11, 9, 1],
      [4, 1, 7],
      [0, 4, 8]
    ]
  }
]
